import * as angular from 'angular';
import { config } from 'angular/utils/config';

export type CalendarByPeriodType = {
    [periodType: string]: UploadableCalendarDto;
};

export interface AuctionCalendarResource
    extends ng.resource.IResourceClass<ng.resource.IResource<any>> {
    uploadableRuntimes: ng.resource.IResourceMethod<
        ng.resource.IResource<CalendarByPeriodType>
    >;
}

function auctionCalendarResource(
    $resource: ng.resource.IResourceService
): AuctionCalendarResource {
    return <AuctionCalendarResource>$resource(
        config.monolithApi + '/auction-calendar',
        {},
        {
            uploadableRuntimes: {
                method: 'GET',
                url:
                    config.monolithApi + '/auction-calendar/uploadable-runtimes'
            }
        }
    );
}

angular
    .module('app')
    .factory('auctionCalendarResource', auctionCalendarResource);
